// Nav Search Menu Generation
jQuery(document).ready(function ($) {
  console.log('initialize srch-nav');

  const $searchURL =
    window.location.protocol + '//' + window.location.host + '/';
  const $searches = $('.srch-nav');
  const $searchMobiles = $('.srch-mobile');
  $searches.each(function () {
    const $search = $(this);
    if (!isMobileNav()) $search.addClass('opens-left');

    const $searchIcon = $search.find('a:first-child');
    const $menu = $(
      `<div role="menubar" class="menu submenu ${
        isMobileNav() ? 'is-dropdown-accordion' : 'is-dropdown-submenu'
      } first-sub vertical border-none"></div>`
    );
    $menu.html(`
     <div id="searchModal" class="search-modal">
      <div class="nav-search-input-wrapper">
        <form role="search" method="get" id="nav-search" class="searchform" action="${$searchURL}" >
          <div class="input-wrapper">
            <input class="nav-search-input" type="search" aria-label="Search" placeholder="Search…" autocorrect="off" autocapitalize="none" autocomplete="off" spellcheck="false" name="s" id="s">
          </div>
          <button class="search-button" type="submit" value="Search">
            <span class="nav-search-icon">
            </span>
          </button>
        </form>
      </div>
    </div>
    `);
    const $input = $menu.find('.nav-search-input');
    $search.append($menu);

    attach($search, $searchIcon, $menu, $input);

    $(window).resize(function () {
      detach($search, $searchIcon);
      attach($search, $searchIcon, $menu, $input);
    });
  });
  $searchMobiles.each(function () {
    const $search = $(this);
    if (!isMobileNav()) $search.addClass('opens-left');

    const $menu = $('.srch-mobile-menu');
    const $input = $menu.find('.nav-search-input');

    const attach = () => {
      $search.off();
      $search.on('click', function () {
        const $mobileMainMenu = $('#top-bar-menu');
        if ($mobileMainMenu.css('display') === 'none') {
          $mobileMainMenu.css('display', 'block');
          $input.focus();
        } else {
          $mobileMainMenu.css('display', 'none');
          $input.blur();
        }
      });
    };

    attach();

    $(window).resize(function () {
      attach();
    });
  });

  if (isMobileNav())
    $searches.each(function () {
      $(this).hide();
    });

  $(window).resize(function () {
    if (isMobileNav()) {
      $searches.each(function () {
        $(this).hide();
      });
    } else {
      $searches.each(function () {
        $(this).show();
      });
    }
  });
});

const DESKTOP_MENU_CLASSES = [
  'menu-item',
  'menu-item-type-custom',
  'menu-item-has-children',
  'is-dropdown-sbmenu-parent',
  'opens-left',
];

const DESKTOP_DROPDOWN_CLASSES = [
  'menu',
  'first-sub',
  'vertical',
  'submenu',
  'is-dropdown-submenu',
];

const MOBILE_MENU_CLASSES = [
  'menu-item',
  'menu-item-type-custom',
  'menu-item-object-custom',
  'menu-item-has-children',
  'is-accordion-submenu-parent',
];

const MOBILE_DROPDOWN_CLASSES = [
  'menu',
  'first-sub',
  'vertical',
  'submenu',
  'is-accordion-submenu',
];
function attach($search, $searchIcon, $menu, $input, defaultToDesktop = false) {
  const toggleClass =
    !defaultToDesktop && isMobileNav() ? 'is-active' : 'js-dropdown-active';
  if (defaultToDesktop || !isMobileNav()) {
    DESKTOP_MENU_CLASSES.forEach((_class) => {
      if (!$search.hasClass(_class)) $search.addClass(_class);
    });

    DESKTOP_DROPDOWN_CLASSES.forEach((_class) => {
      if (!$menu.hasClass(_class)) $menu.addClass(_class);
    });
  } else if (!defaultToDesktop && isMobileNav()) {
    MOBILE_MENU_CLASSES.forEach((_class) => {
      if (!$search.hasClass(_class)) $search.addClass(_class);
    });

    MOBILE_DROPDOWN_CLASSES.forEach((_class) => {
      if (!$menu.hasClass(_class)) $menu.addClass(_class);
    });
  }
  $searchIcon.click(function () {
    $menu.toggleClass(toggleClass);
    if ($menu.hasClass(toggleClass)) $input.focus();
  });

  let timeout = null;
  $search.mouseleave(function () {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      $menu.removeClass(toggleClass);
    }, 1000);
  });
  $search.mouseenter(function () {
    if (timeout) clearTimeout(timeout);
  });
}

function detach($search, $searchIcon) {
  $search.off('mousenter');
  $search.off('mouseleave');
  $searchIcon.off('click');
}

function isMobileNav() {
  return jQuery(window).width() < 900;
}
